// extracted by mini-css-extract-plugin
module.exports = {"gates":"styles_gates__1jzM0","gate":"styles_gate__2gA_r"};